import React from "react";
import { Route, Redirect } from "react-router-dom";

import LoadingScreen from "../components/pages/LoadingScreen";

const ProtectedRoute = ({
  component: Component,
  authProtected = undefined,
  currentUser,
  loading,
  path,
  ...rest
}) => {
  const setComponent = (props) => {
    // FirebaseRemoved
    return <Component {...props} />;
    if (loading) return <LoadingScreen {...props} />;

    if (authProtected) {
      if (currentUser) {
        if (currentUser.MetaData?.Admin) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/unauthorized",
                state: { from: props.location },
              }}
            />
          );
        }
      } else {
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        );
      }
    }

    return <Component {...props} />;
  };

  return <Route path={path} {...rest} render={setComponent} />;
};

export default ProtectedRoute;
